/**
 * Compute a SHA-256 checksum of a file's bytes, returned as a lowercase hex string.
 *
 * Uses the Web Crypto API (`crypto.subtle`), which is only available in
 * secure contexts (HTTPS or localhost). If unavailable, returns null so
 * callers can degrade gracefully rather than fail uploads outright.
 */
export async function computeFileChecksum(file: File | Blob): Promise<string | null> {
  if (typeof crypto === 'undefined' || !crypto.subtle) {
    return null;
  }
  try {
    const buffer = await file.arrayBuffer();
    const hashBuffer = await crypto.subtle.digest('SHA-256', buffer);
    const bytes = new Uint8Array(hashBuffer);
    let hex = '';
    for (let i = 0; i < bytes.length; i++) {
      hex += bytes[i].toString(16).padStart(2, '0');
    }
    return hex;
  } catch {
    return null;
  }
}
